import * as React from 'react';
import { string, array, bool } from 'prop-types';

const MultipleValueTableRow = ({ title, values, color, isFirst, infoTextA, infoTextB }) => {
  return (
    <div
      style={{
        ...{ display: 'flex', flexDirection: 'row', paddingTop: 5, paddingBottom: 5 },
        ...(!isFirst
          ? {
              borderTopWidth: 1,
              borderTopColor: '#6A6A6A',
              borderTopStyle: 'solid',
            }
          : {}),
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', flex: 4, justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ width: 10, height: 10, backgroundColor: color, marginRight: 5, marginTop: 6 }} />
          <p style={{ fontWeight: 600, color: '#6A6A6A' }}>{title || ''}</p>
        </div>
        <div style={{ marginRight: 5 }}>
          {infoTextA ? <p style={{ fontWeight: 400, color: '#6A6A6A' }}>{infoTextA}</p> : <React.Fragment />}
          {infoTextB ? <p style={{ fontWeight: 400, color: '#6A6A6A' }}>{infoTextB}</p> : <React.Fragment />}
        </div>
      </div>
      {(Array.isArray(values) ? values : ['', '', '']).map((value, index) => {
        if (index <= 2) {
          return (
            <div key={value + index} style={itemStyles[index]}>
              <p>{value}</p>
              {values.length > 3 ? <p>{values[index + 3]}</p> : <React.Fragment />}
            </div>
          );
        }
      })}
    </div>
  );
};

MultipleValueTableRow.propTypes = {
  title: string,
  values: array,
  color: string,
  isFirst: bool,
  infoTextA: string,
  infoTextB: string,
};

const SingleValueTableRow = ({ title, value, color, isFirst }) => {
  return <MultipleValueTableRow title={title} values={['', '', value || '']} color={color} isFirst={isFirst} />;
};

SingleValueTableRow.propTypes = {
  title: string,
  value: array,
  color: string,
  isFirst: bool,
};

const SummaryTable = ({ type = 'multipleValue', content }) => {
  switch (type) {
    case 'multipleValue': {
      return (
        <div>
          {content.map((c, i) => (
            <MultipleValueTableRow
              key={i}
              title={c.title}
              values={c.values ? c.values : ['', '', '']}
              color={c.color}
              isFirst={i === 0}
              infoTextA={c.infoTextA}
              infoTextB={c.infoTextB}
            />
          ))}
        </div>
      );
    }
    case 'singleValue': {
      return (
        <div>
          {content.map((c, i) => (
            <SingleValueTableRow
              key={i}
              title={c.title}
              value={c.value ? c.value : ''}
              color={c.color}
              isFirst={i === 0}
            />
          ))}
        </div>
      );
    }
    default: {
      return <React.Fragment />;
    }
  }
};

const itemStyles = [
  // Column 2
  {
    flex: 0.9,
    borderRightWidth: 1,
    borderRightColor: '#6A6A6A',
    borderRightStyle: 'solid',
    textAlign: 'center',
  },
  // Column 3
  {
    flex: 0.9,
    textAlign: 'center',
  },
  // Column 4
  {
    flex: 0.9,
    borderLeftWidth: 1,
    borderLeftColor: '#6A6A6A',
    borderLeftStyle: 'solid',
    textAlign: 'center',
  },
];

export default SummaryTable;
